import { jsx as _jsx } from "react/jsx-runtime";
import { faShareFromSquare } from '@fortawesome/free-regular-svg-icons';
import { excludedErrandButtonRules as excludedRulesSuperConnection } from '../../../unsafe_Connection/excludedErrandButtonRules';
import { errandButtonUtils } from '../../errandButtonUtils';
import { ExecuteActionResult } from '../../ExecuteActionResult';
import { SaveInRegistryButton } from '../SaveInRegistry/SaveInRegistryButton';
import { hideWhenReadOnlyRule } from '../commonRules';
import { reduceButtonRules } from '../Buttons';
import { SendToModal } from './SendToModal';
export const SendToButton = {
    key: 'skicka_till',
    text: 'Skicka till...',
    prio: 2,
    section: 'start',
    icon: faShareFromSquare,
    buttonStyle: 'success',
    ModalComponent: SendToModal,
    onClick: async (row, inca, showModal, ctx, api)=>{
        // do not validate for reviewers
        if (!inca.user.role.isReviewer) {
            const isValid = await ctx.validate();
            if (!isValid) {
                return;
            }
        }
        const { isSuccess, result: { res, transitionShortname } } = await showModal();
        if (!isSuccess) {
            return;
        }
        const stateTransitionResult = await errandButtonUtils.performStateTransition(transitionShortname, ctx, api, res);
        if (!stateTransitionResult) {
            return;
        }
        api.setRootComponent(/*#__PURE__*/ _jsx(ExecuteActionResult, {
            title: "Ärendet sparades",
            isFinished: false,
            stateTransitionResult: stateTransitionResult
        }));
    },
    defaultRules: [
        hideWhenReadOnlyRule,
        {
            id: 'disableWhenSaveButtonIsEnabled',
            description: 'Knappen är disablead för inrapportörer när spara är enabled (enligt defaultregler), inkomplett ej är ikryssad och formuläret inte innehåller valideringsfel.',
            evaluateState: (row, inca, ctx)=>{
                const saveButtonState = reduceButtonRules(inca.form.designedForm.useRegisterRecordConnections ? [
                    ...SaveInRegistryButton.superConnectionRules ?? [],
                    ...SaveInRegistryButton.defaultRules.filter((rule)=>!excludedRulesSuperConnection.includes(rule.id))
                ] : SaveInRegistryButton.defaultRules, ctx);
                if (saveButtonState.state === 'Visible' && !inca.user.role.isReviewer && !ctx.formIncomplete && !ctx.hasErrors && !ctx.options.activateSendToButton) {
                    return {
                        state: 'Disabled',
                        tooltip: `Formuläret är komplett. Använd knappen "${SaveInRegistryButton.text}"`
                    };
                }
                return {
                    state: 'Visible'
                };
            }
        }
    ]
};
